import { Component } from '@angular/core';


@Component({
  selector: '',
  template: ``,
})
export class FeatureComponent {}